"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var Localize_1 = require("../../../gen-src/Localize");
var FormatUtils_1 = require("../../displayUtils/FormatUtils");
var ErrorListProvider_1 = require("../../error/components/ErrorListProvider");
var ErrorToasts_1 = require("../../error/components/ErrorToasts");
var UnrecognizedUrl_1 = require("../../error/components/UnrecognizedUrl");
var SiteUrlsContext_1 = require("../../urls/SiteUrlsContext");
var BrowserTitleUpdater_1 = require("../BrowserTitleUpdater");
var FieldDetailsDialog_1 = require("../FieldDetails/FieldDetailsDialog");
var LineageItemType_1 = require("../lineage/LineageItemType");
var LineageConfiguration_1 = require("../placePage/LineageConfiguration");
var LineageSubplaceLayout_1 = require("../placePage/LineageSubplaceLayout");
var CenteredMessage_1 = require("../widgets/CenteredMessage");
var WorkbookLineageConfiguration_1 = require("./WorkbookLineageConfiguration");
var WorkbookLineageCountsQueryWrapper_1 = require("./WorkbookLineageCountsQueryWrapper");
var WorkbookQueryWrapper_1 = require("./WorkbookQueryWrapper");
var WorkbookSubplaceParamsProvider_1 = require("./WorkbookSubplaceParamsProvider");
var WorkbookLineageSubplaceRouter = /** @class */ (function (_super) {
    __extends(WorkbookLineageSubplaceRouter, _super);
    function WorkbookLineageSubplaceRouter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderWorkbookLineageRoute = function (urls) {
            return (React.createElement(react_router_dom_1.Switch, null,
                WorkbookLineageConfiguration_1.WorkbookLineageConfiguration.map(function (lineageSection) {
                    return lineageSection.items.map(function (lineageItem) {
                        return React.createElement(react_router_dom_1.Route, { path: lineageItem.path(urls, _this.props.vizportalUrlId), render: function () { return _this.renderLineageItemRoute(urls, lineageItem, lineageSection); } });
                    });
                }),
                React.createElement(react_router_dom_1.Redirect, { exact: true, from: urls.workbookLineagePath(_this.props.vizportalUrlId), to: urls.workbookLineageFieldsPath(_this.props.vizportalUrlId) }),
                React.createElement(UnrecognizedUrl_1.UnrecognizedUrl, { backToButtonLabel: Localize_1.Messages.BackToFields(), backToButtonUrl: urls.workbookLineageFieldsPath(_this.props.vizportalUrlId) })));
        };
        _this.renderLineageItemRoute = function (urls, lineageItem, lineageSection) {
            return (React.createElement(WorkbookSubplaceParamsProvider_1.WorkbookSubplaceParamsProvider, null, function (params) {
                return React.createElement(ErrorListProvider_1.ErrorListProvider, null,
                    React.createElement(ErrorToasts_1.ErrorToasts, null),
                    React.createElement(WorkbookQueryWrapper_1.WorkbookQueryWrapper, { vizportalUrlId: _this.props.vizportalUrlId }, function (workbook) {
                        if (workbook.embeddedDatasources.length === 0) {
                            return React.createElement(CenteredMessage_1.CenteredMessage, { message: Localize_1.Messages.EmptyWorkbookLineageMessage() });
                        }
                        var selectedEmbeddedDatasourceId = params.selectedEmbeddedDatasourceId || workbook.embeddedDatasources[0].id;
                        var fieldsCountForSelectedEmbeddedDatasource = _this.getFieldsCountForSelectedEmbeddedDatasource(workbook, selectedEmbeddedDatasourceId);
                        return (React.createElement(WorkbookLineageCountsQueryWrapper_1.WorkbookLineageCountsQueryWrapper, { vizportalUrlId: _this.props.vizportalUrlId, selectedEmbeddedDatasourceId: selectedEmbeddedDatasourceId, selectedKeys: params.selectedFields }, function (_a) {
                            var countsLoading = _a.countsLoading, unfilteredCounts = _a.unfilteredCounts, filteredCounts = _a.filteredCounts;
                            return React.createElement(React.Fragment, null,
                                React.createElement(WorkbookLineageSubplace, { vizportalUrlId: _this.props.vizportalUrlId, workbook: workbook, lineageItem: lineageItem, lineageSection: lineageSection, countsLoading: countsLoading, unfilteredCounts: unfilteredCounts, filteredCounts: filteredCounts, urlSearchValue: params.urlSearchValue, clearFieldSelection: params.clearFieldSelection, selectedKeys: params.selectedFields, updateSelectionForKey: params.updateFieldSelection, selectedEmbeddedDatasourceId: selectedEmbeddedDatasourceId, updateEmbeddedDatasourceSelection: params.updateEmbeddedDatasourceSelection, fieldsCountForSelectedEmbeddedDatasource: fieldsCountForSelectedEmbeddedDatasource, embeddedDatasources: workbook.embeddedDatasources }),
                                lineageSection.sectionType === LineageConfiguration_1.LineageSectionType.Anchor ?
                                    React.createElement(react_router_dom_1.Route, { path: urls.workbookLineageFieldPath(_this.props.vizportalUrlId, ':fieldId'), render: function (_a) {
                                            var history = _a.history, location = _a.location, match = _a.match;
                                            return React.createElement(FieldDetailsDialog_1.FieldDetailsDialog, { fieldId: match.params.fieldId, onClose: function () { return history.replace(__assign({}, location, { pathname: urls.workbookLineageFieldsPath(_this.props.vizportalUrlId) })); } });
                                        } })
                                    : null);
                        }));
                    }));
            }));
        };
        return _this;
    }
    WorkbookLineageSubplaceRouter.prototype.render = function () {
        var _this = this;
        return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) {
            return React.createElement(react_router_dom_1.Route, { path: urls.workbookLineagePath(_this.props.vizportalUrlId), render: function () { return _this.renderWorkbookLineageRoute(urls); } });
        }));
    };
    WorkbookLineageSubplaceRouter.prototype.getFieldsCountForSelectedEmbeddedDatasource = function (workbook, selectedEmbeddedDatasourceId) {
        var datasource = workbook.embeddedDatasources.find(function (d) { return d.id === selectedEmbeddedDatasourceId; });
        if (datasource && datasource.fieldsConnection) {
            return datasource.fieldsConnection.totalCount;
        }
        else {
            return null;
        }
    };
    return WorkbookLineageSubplaceRouter;
}(React.Component));
exports.WorkbookLineageSubplaceRouter = WorkbookLineageSubplaceRouter;
var WorkbookLineageSubplace = /** @class */ (function (_super) {
    __extends(WorkbookLineageSubplace, _super);
    function WorkbookLineageSubplace() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WorkbookLineageSubplace.prototype.render = function () {
        var selectedFields = Object.keys(this.props.selectedKeys);
        var hasFilter = selectedFields.length > 0;
        var filteredFieldId = hasFilter ? selectedFields[0] : null;
        var lineageCounts = this.props.filteredCounts ? this.props.filteredCounts : this.props.unfilteredCounts;
        return (React.createElement(React.Fragment, null,
            React.createElement(BrowserTitleUpdater_1.BrowserTitleUpdater, { name: this.props.workbook.name, browserTitleUpdateType: BrowserTitleUpdater_1.BrowserTitleUpdateType.TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME, subspaceName: Localize_1.Messages.LineageNavHeader() }),
            React.createElement(LineageSubplaceLayout_1.WorkbookLineageSubplaceLayout, { activeLineageItemKey: LineageConfiguration_1.lineageItemKey(this.props), selectedAnchorItemIds: selectedFields, pane: this.props.lineageItem.paneFactory({
                    title: FormatUtils_1.messageWithOrWithoutCount(lineageCounts && this.props.lineageItem.count(lineageCounts), this.props.lineageItem.messagesForPane),
                    selectedKeys: this.props.selectedKeys,
                    updateSelectionForKey: this.props.updateSelectionForKey,
                    vizportalUrlId: this.props.vizportalUrlId,
                    filteredFieldId: filteredFieldId,
                    count: lineageCounts && this.props.lineageItem.count(lineageCounts),
                    selectedEmbeddedDatasourceId: this.props.selectedEmbeddedDatasourceId,
                    updateEmbeddedDatasourceSelection: this.props.updateEmbeddedDatasourceSelection,
                    fieldsCountForSelectedEmbeddedDatasource: this.props.fieldsCountForSelectedEmbeddedDatasource,
                    embeddedDatasources: this.props.embeddedDatasources
                }), workbookId: this.props.vizportalUrlId, countsLoading: this.props.countsLoading, unfilteredCounts: this.props.unfilteredCounts, filteredCounts: this.props.filteredCounts, urlSearchValue: this.props.urlSearchValue, clearFieldSelection: this.props.clearFieldSelection, anchorName: this.props.workbook.name, anchorCount: this.props.embeddedDatasources.length, filteredOnItemType: hasFilter ? LineageItemType_1.LineageItemType.Workbook : null })));
    };
    return WorkbookLineageSubplace;
}(React.PureComponent));
//# sourceMappingURL=WorkbookLineageSubplace.js.map